import React from 'react';
import { useBrand } from '../../../app/config/brand';
import { Button } from '../../../shared/components/ui/Button';
import { Logo } from '../../../shared/components/ui/Logo';

interface LoginPageProps {
  onLogin: () => void;
  onNavigate: (page: string) => void;
}

const LoginPage: React.FC<LoginPageProps> = ({ onLogin, onNavigate }) => {
  const brand = useBrand();
  const text = brand.text.login;

  return (
    <div className="min-h-screen flex flex-col lg:flex-row" style={{ backgroundColor: brand.colors.bgLight }}>
      {/* Left panel - hidden on mobile, shown on lg and up */}
      <div className="hidden lg:flex flex-1 p-8 lg:p-12 flex-col justify-center">
        <Logo className="mb-8 lg:mb-12" />
        <h1 className="text-3xl lg:text-5xl mb-4 lg:mb-6" style={{ fontFamily: brand.typography.fontFamily.heading, color: brand.colors.secondary }}>
          {text.welcome}<br />{brand.company.name}
        </h1>
        <p className="mb-4" style={{ color: brand.colors.textLight }}>
          {text.needHelp} <a href="#" style={{ color: brand.colors.link }} className="font-medium">{text.contactUs}</a> or check out our <a href="#" style={{ color: brand.colors.link }} className="font-medium">Support Center</a>.
        </p>
        <p style={{ color: brand.colors.textLight }}>
          {text.newUser} {brand.company.name}? <button onClick={() => onNavigate('register')} style={{ color: brand.colors.link }} className="font-medium bg-transparent border-none cursor-pointer">{text.createAccount}</button>.
        </p>
      </div>

      {/* Right panel - full width on mobile, fixed width on desktop */}
      <div className="w-full lg:w-[480px] bg-white p-6 sm:p-8 lg:p-12 flex flex-col justify-center shadow-xl min-h-screen lg:min-h-0">
        {/* Mobile logo */}
        <div className="lg:hidden mb-8">
          <Logo className="mb-6" />
        </div>

        <h2 className="text-xl sm:text-2xl font-semibold mb-6 sm:mb-8" style={{ color: brand.colors.secondary }}>{text.loginTitle}</h2>
        <p className="mb-6 text-sm sm:text-base" style={{ color: brand.colors.textLight }}>Click below to sign in with your account.</p>
        <Button className="w-full mb-4" size="lg" onClick={onLogin}>Log In</Button>
        <p className="text-center text-sm" style={{ color: brand.colors.textLight }}>
          Don&apos;t have an account?{' '}
          <button onClick={() => onNavigate('register')} style={{ color: brand.colors.link }} className="font-medium bg-transparent border-none cursor-pointer min-h-touch">Sign up</button>
        </p>
      </div>
    </div>
  );
};

export default LoginPage;
